import { BlogPostContent } from '@/types/blog';
import { mainContent } from './sections/main-content';

export const contentNeu: BlogPostContent = {
  sections: [
    mainContent
  ]
};